<template>
  <div class="recharge__success mt-10">
    <div class="text-center">
      <v-icon
        v-if="!rechargeFields.type === 'ASAAS_PIX'"
        class="recharge__success-icon"
        color="green"
        x-large
      >
        mdi-check-circle-outline
      </v-icon>

      <!-- BILLET -->
      <div v-if="rechargeFields.type === 'ASAAS_BOLETO'">
        <h1 class="my-8 mx-auto mw-300 green--text">
          {{ $t('recharge.billet.successMessage') }}
        </h1>
        <v-btn
          :href="successData.external_doc"
          class="mw-400 mb-5"
          color="primary"
          target="_blank"
          elevation="0"
          x-large
        >
          <v-icon class="mr-5" left>mdi-barcode-scan</v-icon>
          {{ $t('recharge.billet.download') }}
        </v-btn>
      </div>
      <!-- /BILLET -->

      <!-- CREDIT CARD -->
      <div v-if="rechargeFields.type === 'ASAAS_CREDIT_CARD'">
        <h1 class="my-8 mx-auto mw-400 green--text">
          {{ $t('recharge.card.successMessage') }}
        </h1>
      </div>
      <!-- /CREDIT CARD -->

      <!-- PIX -->
      <div v-if="rechargeFields.type === 'ASAAS_PIX'">
        <h1 class="mt-8 mb-2 mx-auto mw-400">
          {{ $t('recharge.pix.withPix') }}
        </h1>
        <p>
          {{ $t('recharge.pix.description') }}
        </p>
        <img
          alt="PIX QR CODE"
          width="300"
          height="auto"
          :src="`data:image/jpeg;base64,${successData.pix_qrcode_image}`"
        />
        <v-divider class="my-8" />
        <v-textarea
          :value="successData.pix_string_code"
          outlined
          readonly
          small
        />
        <div class="d-flex justify-center">
          <v-chip>
            <v-progress-circular
              :size="10"
              :width="1"
              class="mr-2"
              indeterminate
            />
            {{ $t(`recharge.status.${successData.status}`) }}
          </v-chip>
        </div>
      </div>
      <v-divider class="my-8" />
      <!-- /PIX -->

      <v-btn
        @click="
          () => {
            this.$emit('endInterval')
            setRechargeFields({ type: null })
            setSuccessData(null)
          }
        "
        class="mw-250 mb-5"
        elevation="0"
        color="grey"
        text
      >
        <v-icon left>
          mdi-chevron-left
        </v-icon>
        {{ $t('recharge.navigation.goBack') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'RechargeSuccess',

  data() {
    return {
      _interval: null,
    }
  },

  watch: {
    pixData(pix) {
      if (pix?.status === 'RECEIVED') {
        const modal = this.$parent.$parent.$parent.$parent.$parent.$parent
        this.setRechargeFields({ type: null })
        this.setSuccessData(null)
        this.fetchRecharges()
        modal.dialog = false

        this.showSuccessMessage(this.$t('recharge.pix.successMessage'))
        this.$emit('endInterval')
      }
    },
  },

  computed: {
    ...mapGetters(['successData', 'pixData', 'rechargeFields', 'isLoading']),
  },

  methods: {
    ...mapActions(['showSuccessMessage', 'fetchRecharges']),
    ...mapMutations(['setRechargeFields', 'setSuccessData']),
  },

  mounted() {
    if (this.rechargeFields.type === 'ASAAS_PIX' && this.rechargeFields.value) {
      this.$emit('startInterval')
    }
  },
}
</script>
